module.exports = __webpack_public_path__ + "static/media/opintrack-inline.70e49991.svg";